// MadeOfWonder: dot navigation for the product gallery on mobile (thumbnails are hidden there).
// Dawn's SliderComponent keeps doing the scrolling; the dots follow its `slideChanged` event and
// scroll the slider when tapped.
(() => {
  const build = (gallery) => {
    const dots = gallery.querySelector('[data-mw-dots]');
    if (!dots || !gallery.slider) return;
    const pages = gallery.totalPages || 0;
    if (dots.childElementCount !== pages) {
      dots.replaceChildren(
        ...Array.from({ length: pages }, (_, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'mw-dots__dot';
          dot.setAttribute('aria-label', `Show image ${i + 1} of ${pages}`);
          dot.addEventListener('click', () =>
            gallery.slider.scrollTo({ left: gallery.sliderItemOffset * i, behavior: 'smooth' })
          );
          return dot;
        })
      );
    }
    dots.hidden = pages < 2;
    [...dots.children].forEach((dot, i) => {
      const active = i === (gallery.currentPage || 1) - 1;
      dot.classList.toggle('is-active', active);
      dot.toggleAttribute('aria-current', active);
    });
  };

  const init = () => {
    document.querySelectorAll('slider-component[id^="GalleryViewer-"]').forEach((gallery) => {
      if (gallery.dataset.mwDots) return;
      gallery.dataset.mwDots = '1';
      gallery.addEventListener('slideChanged', () => build(gallery));
      new ResizeObserver(() => requestAnimationFrame(() => build(gallery))).observe(gallery);
      build(gallery);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
